import { all, put, takeEvery } from 'redux-saga/effects';
import gql from 'graphql-tag';
import { client } from '../apollo';
import { authenticate } from '../actions/session';
import { loginSucceededAction, loginFailedAction } from '../actions/login';
import { loadUserAction } from '../actions/user';
import { history } from '../store';


function* handleLoginSubmit(action) {
  // Função executada no momento em que o usuário clica no botão submit,
  // para logar no portal.
  // O parâmetro action contém um atributo `payload` que é o objeto de valores do formulário.

  // Cria um token de acesso no portal
  const GET_TOKEN_AUTH = gql`
    mutation portalAuth($username: String!, $password: String!) {
      portalAuth(username: $username, password: $password) {
        token
      }
    }
  `;

  const variables = action.payload;
  
  try {
    const { data } = yield client.mutate({
      mutation: GET_TOKEN_AUTH,
      variables
    });
    
    const { portalAuth } = data;
    const { token } = portalAuth;

    console.log("oi" + data)
    yield put(authenticate(token));
    yield put(loginSucceededAction());
  
  } catch(error) {
    // A mesma action especificada no formulário. Tem como objetivo
    // desbloquear o botão submit do formulário.
    yield put(loginFailedAction());
    alert("erro" + error.message);
  }
}

function* watchLoginSubmit() {
  yield takeEvery('LOGIN_SUBMIT', handleLoginSubmit);
}

function* handleAuthenticate(action) {
  const session = {
    token: action.payload.token,
    authenticated: true
  };
  sessionStorage.setItem('token', session.token);
}

function* watchAuthenticate() {
  yield takeEvery('AUTHENTICATE', handleAuthenticate);
}


function* handleLoginSucceeded(action) {
  // Função executada após o usuário obter um token de autenticação.
    yield put(loadUserAction());
    history.push('/');
}

function* watchLoginSucceeded() {
  yield takeEvery('LOGIN_SUCCEEDED', handleLoginSucceeded);
}

export default function* root() {
  yield all([
    watchLoginSubmit(),
    watchLoginSucceeded(),
    watchAuthenticate(),
    // watchStopSubmit(),
    // watchSearchSuccess()
  ]);
}



// WEBPACK FOOTER //
// ./src/sagas/login.js